export default __webpack_public_path__ + "static/media/topBanner3crop-min.8c748816.png";